export default __webpack_public_path__ + "static/media/dark-enterprise-icon.2bb2b8cf.svg";